import { css } from 'styled-components'
import { tryCatch, pipe, over, toUpper, join, lensIndex } from 'ramda'

const tryTo = fn => tryCatch(fn, () => '')

const capitalize = tryTo(pipe(over(lensIndex(0), toUpper), join('')))

export const sizes = {
  desktop: [1025, 1280],
  laptop: [769, 1024],
  tablet: [481, 768],
  mobile: [320, 480],
}

/**
 *  Iterate through the sizes and create a media template
 *  const media = {
 *    aboveDesktop: @media(...) { ...css }
 *    desktopAndUp: @media(...) { ...css }
 *    desktop: @media(...) { ...css }
 *    desktopAndBelow: @media(...) { ...css }
 *    belowDesktop: @media(...) { ...css }

 *    aboveLaptop: @media(...) { ...css }
 *    laptopAndUp: @media(...) { ...css }
 *    laptop: @media(...) { ...css }
 *    laptopAndBelow: @media(...) { ...css }
 *    belowLaptop: @media(...) { ...css }

 *    aboveTablet: @media(...) { ...css }
 *    tabletAndUp: @media(...) { ...css }
 *    tablet: @media(...) { ...css }
 *    tabletAndBelow: @media(...) { ...css }
 *    belowTablet: @media(...) { ...css }

 *    aboveMobile: @media(...) { ...css }
 *    mobileAndUp: @media(...) { ...css }
 *    mobile: @media(...) { ...css }
 *    mobileAndBelow: @media(...) { ...css }
 *    belowMobile: @media(...) { ...css }
 *  }
 */

/**
 * @description styled-component media query helper
 * @type {object}
 * @property {string} belowDesktop - min-width: 899px
 * @property {string} belowTablet - min-width: 599px
 */

export const media = Object.keys(sizes).reduce((acc, label) => {
  // "aboveDesktop"
  acc['above' + capitalize(label)] = (...args) => css`
    @media (min-width: ${sizes[label][1] + 1}px) {
      ${css(...args)};
    }
  `

  // "desktopAndUp"
  acc[label + 'AndUp'] = (...args) => css`
    @media (min-width: ${sizes[label][0]}px) {
      ${css(...args)};
    }
  `

  // "desktop"
  acc[label] = (...args) => css`
    @media (min-width: ${sizes[label][0]}px) and (max-width: ${sizes[
        label
      ][1]}px) {
      ${css(...args)};
    }
  `

  // "desktopAndBelow"
  acc[label + 'AndBelow'] = (...args) => css`
    @media (max-width: ${sizes[label][1]}px) {
      ${css(...args)};
    }
  `

  // "belowDesktop"
  acc['below' + capitalize(label)] = (...args) => css`
    @media (max-width: ${sizes[label][0] - 1}px) {
      ${css(...args)};
    }
  `

  return acc
}, {})
